/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {

	/**
	 * @interface ThemeDefinitionAPI
	 * @classdesc API class that defines the user profile info accessible in a dashboard
	 */
	class ThemeDefinitionAPI {

		/**
		 * Gets the css colors for the specified variable
		 * @param {string} variableName - the variable to get the css colors for
		 * @return {Object} the css colors for the variableName arg
		 */
		getCSSColors() {}

		/**
		 * Get the default palette name
		 * @param {string} paletteType the type of palette. Options are 'ColorPalette', 'HeatPalette' and 'ConditionalPalette'
		 * @returns {string}
		 */
		getDefaultPaletteName() {}

		/**
		 * Gets the id of the theme definition
		 * @returns {String} - id of ThemeDefinition
		 */
		getId() {}

		/**
		 * Gets the UI element
		 * @param {String} name - the name of the UI element
		 * @returns {Array} the array of the UI element
		 */
		getUIElement() {}

		/**
		 * Get a specific palette either directly by id or by an aliased id in the
		 * case of looking for an older palette id from different/older themes.
		 * @param {string} paletteId the palette ID value to get
		 * @param {string} paletteVariableName The theme variable name to look at for the paletteId; examples: 'ColorPalette','HeatPalette', 'ContinuousPalette'
		 * @param {boolean} [forProperties=false] boolean if the response is to be used for the properties.
		 * @return {object} Either a palette object directly when 'forProperties' boolean is false or if it is true
		 * then a CMResponse-like object of the found palette or if none found than the first/default palette
		 */
		getPalette() {}

		/**
		 * Get all the palettes defined in the theme
		 * @param {String} paletteVariableName - the theme variable name for the list of palettes ('ColorPalette', 'HeatPalette', 'ContinuousPalette')
		 * @param {Boolean} forProperties - boolean if the response is to be used for the properties
		 * @param {Boolean} includePatternPalettes - Should pattern palettes be included in the list of returned palettes.
		 * @return {Array} all palettes defined in the theme
		 */
		getPalettes() {}

		/**
		 * Get the property value for the UIElement and Property ID specified
		 * @param {String} uiElement - UIElement as described in the theme
		 * @param {String} propertyId - property within the specified UIElement
		 * @returns {Object} - value for the property if it exists, undefined otherwise
		 */
		getPropertyForUIElement() {}

		/**
		 * Get the property value for the UIElement and Property ID specified
		 * @param {String} uiElement - UIElement as described in the theme
		 * @param {String} propertyId - property within the specified UIElement
		 * @returns {Object} - value for the property if it exists, undefined otherwise
		 */
		getValueForPropertyOfUIElement() {}

		/**
		 * Given the variable type (such as 'Color' or 'Font') and the variable ID
		 * (such as 'color1' or 'font1') return the value for the corresponding mapping
		 * @param {String} variableType - Variable type (such as 'Color' or 'Font')
		 * @param {String} variableId - id of a variable found within the specified variableType (such as 'color1')
		 * @returns {Object} value if the specified variable exists.
		 */
		getValueForVariable() {}

		/**
		 * Generates an array of id and foreground color pairs
		 * @param {String} bgColor - String defining the background color eg. color3¿
		 * @param {String} uiElement - UIElement as described in the theme eg. visualization
		 * @returns {Array} array of id and foreground color pairs that are type is one of FOREGROUND_PALETTES in given elements
		 */
		getForegroundColorPropertiesForUIElement() {}

		/**
		 * Generates an array of id and foreground color pairs
		 * @param {String} uiElement - UIElement as described in the theme eg. visualization
		 * @returns {Array} array of properties for ui elements
		 */
		getForegroundPropertiesForUIElement() {}


		/**
		 * @function ThemeDefinitionAPI#getProperty
		 * @description Get a property value from the theme definition
		 * @param {String} name
		 * @returns {Object} Property value
		 */
		getProperty() {}
	}
	return ThemeDefinitionAPI;
});
